module.exports = __webpack_public_path__ + "cu.svg?e4f897dc1790e9f3d1adafb62d0f7fd1";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/cu.svg
// module id = 1311
// module chunks = 0